require('normalize.css/normalize.css');
require('styles/App.css');
//require('prop-types');
import PropTypes from 'prop-types';
import React from 'react'
import Schedule from './Schedule'
import Past from './Past'
import Calendar from './Calendar'
import Vvatar from './Avatar';
//import YouTube from './Zoutube';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Proba from './Proba';
class AppComponent extends React.Component {
	 
  render() {
    return (
 
      <div className="index">
	  <div className="header"><Vvatar /><div className="headeric"><Schedule /></div></div>
<div className="notice"><p>Klik na današnji datum otvara kalendar na kome možete predložiti sledeći termin, administrator odgovara na portalu:</p>
<Proba />
</div>
	 <Past />
  </div>  );
  }
}

AppComponent.PropTypes = {
};
//ExampleCustomInput.propTypes = {
//  onClick: PropTypes.func,
//  value: PropTypes.string
//};
export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js